import React from 'react';
import './Footer.css';

const Footer = () => {
  return <div className='Footer'>Made with ❤️ by Piyush Jain</div>;
};

export default Footer;
